var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3904_7881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3486 0V4.15646H37.8381L42.3486 6.68571V12.1333L35.1537 8.02993L27.9588 12.4163V6.98639L32.4328 4.15646H27.9406V0H42.3486Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5034 15.9537H34.898V13.9551H29.3832V26H50V0H44.4851V15.9537H44.5034ZM44.5034 21.8435H34.898V20.3932H44.5034V21.8435Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5074 0H13.6786V5.3415H18.9926V13.9551H24.5074V0Z",
    fill: "#0073EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9031 5.3415V0H4.12819H0.0742188V5.3415V8.91429V13.9551H4.12819H10.9031V8.91429H5.47952V5.3415H10.9031Z",
    fill: "#0073EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3904_7881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.60d4d4bf03c69d5ff8bc17e9baa9136d.svg";
export { ForwardRef as ReactComponent };